module.exports = __webpack_public_path__ + "img/galeria_stack_6.9a8f25b7.webp";